import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

/**
 * Registers every component under `src/components/` globally.
 *
 * This is not a bootstrap detail: the whole project depends on it. Almost no `.vue`
 * file imports the components it uses in its template; they resolve because this file
 * registers all ~300 of them at once.
 *
 * Vue 2 used `require.context`, which is webpack-only. The Vite equivalent is
 * `import.meta.glob` with `eager: true` (the lazy form returns Promises, and global
 * registration needs the resolved component).
 *
 * The original pattern also matched stray `.js` files in the folder, including this
 * one, which Vue 2 silently registered as a component named "Globals". It is skipped
 * here, as is any `.js` helper that exports something that is not a component.
 */
const modulos = import.meta.glob('./**/*.{vue,js}', { eager: true });

export function registrarGlobais(app) {
  for (const [caminho, modulo] of Object.entries(modulos)) {
    if (caminho.endsWith('/_globals.js')) continue;

    const nome = upperFirst(camelCase(caminho.split('/').pop().replace(/\.\w+$/, '')));
    const componente = modulo.default || modulo;
    if (!componente || (typeof componente === 'function' && !componente.render)) continue;

    app.component(nome, componente);
  }
}
